export default [
  {
    path: "/settings/organization-information",
    name: "OrganizationInformation",
    component: () => import("@/views/EnterpriseCustomer/Settings/OrganizationInformation/index.vue"),
  },
   {
    path: "/settings/preferences",
    name: "Preferences",
    component: () => import("@/views/EnterpriseCustomer/Settings/Preferences/index.vue"),
  },
  {
    path: "/settings/account/security",
    name: "EnterpriseAccountSecurity",
    component: () => import("@/views/EnterpriseCustomer/Settings/AccountSecurity/index.vue"),
  },
  {
    path: "/settings/all",
    name: "EnterpriseSettingsSelect",
    component: () => import("@/views/EnterpriseCustomer/Settings/index.vue"),
  },
  {
    path: "/settings/domain",
    name: "SettingsDomain",
    component: () => import("@/views/Ondemand/Domains.vue"),
  },
  {
    path: "/settings/payment",
    name: "SettingsPayment",
    component: () => import("@/views/Ondemand/Settings/Payment.vue"),
  },
  {
    path: "/settings/wallet-details",
    name: "SettingsWalletDetails",
    component: () => import("@/views/Ondemand/Settings/WalletDetails.vue"),
  },
  {
    path: "/settings/cards",
    name: "SettingsCardsDetails",
    component: () => import("@/views/Ondemand/Settings/Cards.vue"),
  },
];

